import React from "react";

import { Box, Radio, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import { scenes } from "../../../lib/helpers";

interface Props {
  authenticated: boolean;
  onUpdate: (sceneIdentifier: string) => void;
  value: string;
}

const SceneSelect: React.FC<Props> = ({ authenticated, onUpdate, value }) => {
  const intl = useIntl();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        maxWidth: "100%",
        pl: "30px",
        pr: "30px",
        gap: "1.5rem",
      }}
    >
      {scenes.map((scene) => {
        const allowSelect = authenticated || scene.premiumType === "NONE";
        return (
          <Box
            flexDirection="column"
            display="flex"
            width="100%"
            key={scene.identifier}
          >
            <Box
              display="flex"
              position="relative"
              sx={
                allowSelect
                  ? {
                      cursor: "pointer",
                    }
                  : {}
              }
            >
              {allowSelect && (
                <Radio
                  name="sceneIdentifier"
                  size="small"
                  sx={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "10px",
                    left: "2px",
                    background: "#ffffff",
                    maxHeight: "20px",
                    maxWidth: "20px",
                  }}
                  checked={value === scene.identifier}
                  onChange={() => onUpdate(scene.identifier)}
                />
              )}
              <img
                style={{
                  width: "192px",
                  height: "92px",
                }}
                src={scene.image}
                title={intl.formatMessage(scene.name)}
                alt={intl.formatMessage(scene.name)}
                onClick={
                  allowSelect ? () => onUpdate(scene.identifier) : undefined
                }
              />
            </Box>
            <Box display="flex" justifyContent="center" flexDirection="column">
              <Typography>
                <FormattedMessage {...scene.name} />
              </Typography>
              <Typography fontSize="0.8em">
                <FormattedMessage {...scene.description} />
              </Typography>
            </Box>
          </Box>
        );
      })}
      {!authenticated ? (
        <Box>
          <Box style={{ margin: "2em" }}>
            <FormattedMessage
              id="rooms.create-an-account-to-select-the-other-rooms"
              defaultMessage="<a>Create an account</a> to select the other rooms"
              values={{
                a: (...chunks) => <a href="/users/register">{chunks}</a>,
              }}
            />
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};

export default SceneSelect;
